import React from "react";

export default function Venue() {
  return (
    <div style={{ marginTop: "7rem" }}>
      <div className="about  mt-3">
        <div className="card border-primary mb-3" style={{ width: "auto" }}>
          <div className="card-body">
            <h5 className="card-title text-primary">CONFERENCE VENUE</h5>
            <h6 className="card-subtitle mb-2 text-muted">&nbsp;</h6>
            <div>
              {/* <!--ADDRESS--> */}
              <div className="contact">
                <div className="card">
                  <div className="card-body">
                    <p>
                      Onsite @ <br /> Kongunadu College of Engineering and
                      Technology, <br />
                      Thottiam, Trichy.
                      <br />{" "}
                      <strong>Accomadation will be arranged in College</strong>
                    </p>
                  </div>
                </div>
                {/* <!--/ADDRESS-->
                    <!--MAP--> */}
                <div className="card">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3916.3041807337145!2d78.2953629147511!3d11.015789092159325!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3baaf5b7515b26d3%3A0xe23944ddca3a0296!2sKongunadu%20College%20of%20Engineering%20and%20Technology!5e0!3m2!1sen!2sin!4v1605192020542!5m2!1sen!2sin"
                    width="auto"
                    height="300"
                    frameborder="0"
                    style={{ border: "0" }}
                    allowfullscreen=""
                    aria-hidden="false"
                    title="venue"
                    tabindex="0"
                  ></iframe>
                </div>
                {/* <!--/MAP--> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
